// Constants for About formulas

// Source sets definitions
export const CURATED_SOURCES_GDA = [
  'CLINGEN',
  'CLINPGX',
  'CLINVAR',
  'GENCC',
  'MGD HUMAN',
  'RGD HUMAN',
  'ORPHANET',
  'PSYGENET',
  'UNIPROT',
];

export const CURATED_SOURCES_VDA = ['CLINGEN', 'CLINPGX', 'CLINVAR', 'GWASCAT', 'PHEWASCAT', 'UNIPROT'];

export const CLINICAL_TRIALS_SOURCES = ['CLINICAL TRIALS'];

export const INFERRED_SOURCES = [
  'FINNGEN',
  'GWASCAT',
  'HPO',
  'PHEWASCAT',
  'UKBIOBANK',
  'CHEMBL',
] as const;

export const INFERRED_SOURCE_API_IDS = [
  'INFERRED',
  'FINNGEN',
  'GWASCAT',
  'HPO',
  'PHEWASCAT',
  'UKBIOBANK',
  'CHEMBL',
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES = [
  'Altered Expression',
  'Biomarker',
  'CNV',
  'Causal Mutation',
  'Cell Marker',
  'Epigenomic Alterations',
  'Fusion Gene',
  'Non-coding RNA Regulation',
  'Other',
  'Pharmacogenomics',
  'Post-translational Modification',
  'Protective Mutation',
  'Susceptibility Mutation',
  'Therapeutic Target',
  'Upregulation',
  'Downregulation',
  'Accumulation and Aggregation',
  'Activity',
  'QTL',
] as const;

export const RELATION_EXTRACTION_ASSOCIATION_TYPES_GDA = RELATION_EXTRACTION_ASSOCIATION_TYPES;

/** Legacy GDA association types (space-separated labels matching the filters API). */
export const LEGACY_ASSOCIATION_TYPES_GDA = [
  'Causal Or Contributing',
  'Chromosomal Rearrangement',
  'Drug Response',
  'Genetic Variation',
  'Germline Causal Mutation',
  'Germline Modifying Mutation',
  'Somatic Causal Mutation',
] as const;

export const ASSOCIATION_TYPES_GDA = [
  ...RELATION_EXTRACTION_ASSOCIATION_TYPES,
  ...LEGACY_ASSOCIATION_TYPES_GDA,
] as const;

/** Legacy VDA association types (space-separated labels matching the filters API). */
export const LEGACY_ASSOCIATION_TYPES_VDA = [
  'Drug Response',
  'Genetic Variation',
  'Protective',
  'VUS',
] as const;

export const ASSOCIATION_TYPES_VDA = [
  ...RELATION_EXTRACTION_ASSOCIATION_TYPES,
  ...LEGACY_ASSOCIATION_TYPES_VDA,
] as const;

export const MODELS_SOURCES = ['MGD MOUSE', 'RGD RAT', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES = ['TEXTMINING HUMAN', 'TEXTMINING MODELS'];

export const LITERATURE_SOURCES_VDA = ['TEXTMINING HUMAN'];

export const BIOBANK_SOURCES = ['FINNGEN', 'UKBIOBANK'];

// Common MathML namespace
export const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
